import { Label, Select, SelectProps } from 'semantic-ui-react';
import './styles.css';

type LabeledDropdownPropsType = {
    label: string;
} & SelectProps;

const LabeledDropdown = ({ label, ...props }: LabeledDropdownPropsType) => {
    return (
        <div className="labeled-dropdown">
            <Label size="large" className="labeled-dropdown__label">
                {label}
            </Label>
            <Select className="labeled-dropdown__select" {...props} />
        </div>
    );
};

export default LabeledDropdown;
